    <div class="modal-body margin-top mt24 margin-bottom mb8" [ngClass]="{'ma-billing-qtn-error': !isAcmic}">
        <div class="margin-top mt24 margin-bottom mb8 text-center ma-billing-qtn-sec">
            <ng-container *ngIf="isAcmic; else maState">
                <div>                
                    <svg-email-error-svg></svg-email-error-svg>                                
                </div>
                <h1 class="title-copy margin-top mt20 margin-bottom mb16 red-text"> {{ 'BILLING_COMMENT_REQUEST_SUBMIT_PROBLEM' | translate }}</h1>
                <div class="margin-top mt24 margin-bottom mb12">{{ 'PLEASE_TRY_AGAIN' | translate }}</div>
                <div class="margin-top mt24 margin-bottom mb16">{{ 'BILLING_COMMENT_CONTACT_BILLING' | translate }}</div>
            </ng-container>
            <ng-template #maState>
                <div>
                    <img src="./assets/img/images/icon-warning.svg" alt="warning icon" />
                </div>
                <h1 class="title-copy"> {{ 'BILLING_COMMENT_REQUEST_SUBMIT_PROBLEM' | translate }}</h1>
                <div class="margin-bottom mb20 font-weight-500">{{ 'PLEASE_TRY_AGAIN' | translate }}</div>
                <div class="margin-bottom mb8">{{ 'BILLING_COMMENT_CONTACT_BILLING' | translate }}</div>
            </ng-template>                                
            <ng-container *ngIf = "isAcmic; else otherState">
                <div class="col margin-bottom mb4"><span class="phone-text">{{ 'PHONE' | translate }}:&nbsp;</span><span class="blue-text">{{ 'CUSTOMER_SERVICE_NUMBER' | translate }}</span> </div>
                <div class="info margin-bottom mb4">{{ 'CONTACT_CENTER_HOURS_ACMIC' | translate }}</div>
            <div class="info margin-bottom mb4">{{ 'CONTACT_CENTER_HOURS_2_ACMIC' | translate }}</div>
            </ng-container>
            <ng-template #otherState>
            <a href="tel:18556273737" class="mapfre link underline red-link">1-855-627-3737</a>  
            <div class="margin-bottom mb8 margin-top mt8 font-weight-500">{{ 'CONTACT_CENTER_HOURS' | translate }}</div>
            <div class="font-weight-500">{{ 'CONTACT_CENTER_HOURS_2' | translate }}</div>
            <hr class="ma-hr-tag">
        </ng-template>
        </div>
        <ng-container *ngIf="isAcmic; else maButtonActions">
            <div class="col text-center margin-top mt24">
                <mapfre-button [additionalClasses]="'basic primary large-btn'"
                (click)="onReloadForm()">
                    {{ 'TRY_AGAIN' | translate }}
                </mapfre-button>
            </div>
            <div class="row text-center margin-top mt24">
                <div class="col">
                    <mapfre-button additionalClasses="link-button small blue-link" [iconClasses]="'align-middle'" (click)="onClickBack()"> {{ 'Cancel' | translate }}
                    </mapfre-button>
                </div>
            </div>
        </ng-container>
        <ng-template #maButtonActions>
            <div class="w-100">
                <div class="show-btn-order">
                    <mapfre-button additionalClasses="ghost secondary small-btn modal-small-btn" [iconClasses]="'align-middle'"
                        (click)="onClickBack()"> {{ 'Cancel' | translate }}
                    </mapfre-button>
                    <mapfre-button [additionalClasses]="'basic primary small-btn modal-small-btn'" (click)="onReloadForm()">
                        {{ 'TRY_AGAIN' | translate }}
                    </mapfre-button>
                </div>
            </div>
        </ng-template>
    </div>
